import React from 'react';
import { Row } from '../../containers';
import { type AltoIcon } from '../../icon';
import { XsSpacing } from '../../separators';

export type IconRowProps = {
  readonly right?: boolean;
  readonly icon: React.ReactElement<typeof AltoIcon>;
  readonly children: React.ReactNode;
};

export const IconRow = ({ children, icon, right }: IconRowProps) => {
  return (
    <Row centerVertically>
      {!right && (
        <Row>
          {icon}
          <XsSpacing />
        </Row>
      )}
      <Row flexShrink={1}>{children}</Row>
      {right ? (
        <Row>
          <XsSpacing />
          {icon}
        </Row>
      ) : null}
    </Row>
  );
};
